import PipingModal from 'sma.admin/components/pipes';
import VideoWindowModal from 'sma.admin/components/videowindow';
import { removeIframesExcept } from 'sma.common/utils';

const ajax = require('sma.common/ajax');

// Create a default icon template and set it as the active icon set
$.FroalaEditor.DefineIconTemplate('nucleo', '<i class="nc-icon-mini [NAME]"></i>');
$.FroalaEditor.ICON_DEFAULT_TEMPLATE = 'nucleo';

// Assign buttons to new icon identifiers
$.FroalaEditor.DefineIcon('fullscreen', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('fullscreenCompress', { NAME: 'gestures_pinch' });

$.FroalaEditor.DefineIcon('bold', { NAME: 'text_bold' });
$.FroalaEditor.DefineIcon('italic', { NAME: 'text_italic' });
$.FroalaEditor.DefineIcon('underline', { NAME: 'text_underline' });
$.FroalaEditor.DefineIcon('strikeThrough', { NAME: 'text_strikethrough' });
$.FroalaEditor.DefineIcon('paragraphFormat', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('specialCharacters', { NAME: 'business_currency-euro' });
$.FroalaEditor.DefineIcon('subscript', { NAME: 'text_subscript' });
$.FroalaEditor.DefineIcon('superscript', { NAME: 'text_superscript' });

$.FroalaEditor.DefineIcon('fontFamily', { NAME: 'text_edit' });
$.FroalaEditor.DefineIcon('fontSize', { NAME: 'text_size' });
$.FroalaEditor.DefineIcon('color', { NAME: 'text_color' });

$.FroalaEditor.DefineIcon('align', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('align-justify', { NAME: 'text_align-justify' });

$.FroalaEditor.DefineIcon('formatOL', { NAME: 'text_list-numbers' });
$.FroalaEditor.DefineIcon('formatUL', { NAME: 'text_list-bullet' });
$.FroalaEditor.DefineIcon('outdent', { NAME: 'text_margin-right' });
$.FroalaEditor.DefineIcon('indent', { NAME: 'text_margin-left' });
$.FroalaEditor.DefineIcon('quote', { NAME: 'text_quote' });

$.FroalaEditor.DefineIcon('insertLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('insertImage', { NAME: 'design_image' });
$.FroalaEditor.DefineIcon('insertTable', { NAME: 'media-1_grid' });

$.FroalaEditor.DefineIcon('insertHR', { NAME: 'ui-1_simple-delete' });
$.FroalaEditor.DefineIcon('clearFormatting', { NAME: 'ui-2_ban' });

$.FroalaEditor.DefineIcon('html', { NAME: 'design_code' });
$.FroalaEditor.DefineIcon('piping', { NAME: 'arrows-2_round-up-right' });
$.FroalaEditor.DefineIcon('insertVideo', { NAME: 'media-1_video-65' });

$.FroalaEditor.DefineIcon('undo', { NAME: 'arrows-1_refresh-68 flip-y' });
$.FroalaEditor.DefineIcon('redo', { NAME: 'arrows-1_refresh-68' });

$.FroalaEditor.DefineIcon('linkOpen', { NAME: 'arrows-e_share-26' });
$.FroalaEditor.DefineIcon('linkStyle', { NAME: 'design_wand' });
$.FroalaEditor.DefineIcon('linkEdit', { NAME: 'ui-1_edit-76' });
$.FroalaEditor.DefineIcon('linkRemove', { NAME: 'ui-2_link-broken-70' });

$.FroalaEditor.DefineIcon('linkBack', { NAME: 'arrows-1_simple-left' });
$.FroalaEditor.DefineIcon('linkList', { NAME: 'ui-1_zoom' });

$.FroalaEditor.DefineIcon('imageReplace', { NAME: 'arrows-1_direction-53' });
$.FroalaEditor.DefineIcon('image-align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('image-align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('image-align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('imageRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('imageLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageDisplay', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('imageStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('imageAlt', { NAME: 'ui-2_alert-i' });
$.FroalaEditor.DefineIcon('imageSize', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('imageUpload', { NAME: 'arrows-2_square-upload' });
$.FroalaEditor.DefineIcon('imageByURL', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageBack', { NAME: 'arrows-1_simple-left' });

$.FroalaEditor.DefineIcon('tableHeader', { NAME: 'travel_hotel-symbol' });
$.FroalaEditor.DefineIcon('tableRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('tableRows', { NAME: 'ui-2_menu-34' });
$.FroalaEditor.DefineIcon('tableColumns', { NAME: 'ui-2_menu-34 rotate-90' });
$.FroalaEditor.DefineIcon('tableStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('tableCells', { NAME: 'design_slice' });
$.FroalaEditor.DefineIcon('tableCellBackground', { NAME: 'ui-1_drop' });
$.FroalaEditor.DefineIcon('tableCellVerticalAlign', { NAME: 'arrows-1_enlarge-vertical' });
$.FroalaEditor.DefineIcon('tableCellStyle', { NAME: 'design_wand' });

// $.FE.DEFAULTS.imageInsertButtons = ['imageBack', '|', 'imageByURL'];

/**
 * We have to disable this rule since the function to convert texteditors to Froalas will not work.
 * This is a bit of a hack and just works because of how it ends up being imported.  Should likely
 * be a bit more explicit - update when upgrade to Froala v3.
 */

/* eslint-disable import/prefer-default-export */
export class TextEditor {
	constructor(options) {
		this.pipingContext = options.piping || null;
		this.disableVideo = options.disableVideo || false;
		this.el = $(options.textarea);
		this.fromModal = options.fromModal || false;
		this.initialCodeViewContent = '';
		const that = this;

		const buttons = options.buttons || [
			'fullscreen',
			'|', 'bold', 'italic', 'underline', 'paragraphFormat',
			'fontSize', 'color', 'strikeThrough', 'subscript', 'superscript',
			'|', 'align',
			'|', 'formatOL', 'formatUL', 'outdent', 'indent',
			'-', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'specialCharacters', 'insertHR',
			'|', 'undo', 'redo', 'clearFormatting',
			'|', 'html',
			'|', 'piping',
		];

		let config = {};

		if (!this.disableVideo) {
			$.FroalaEditor.RegisterCommand('insertVideo', {
				title: 'Video',
				focus: false,
				undo: false,
				refreshAfterCallback: false,
				/* eslint-disable func-names, object-shorthand */
				callback: function () {
					/* eslint-disable no-new */
					new VideoWindowModal({
						context: {},
						$textField: this.$oel,
						froala: that,
						fromModal: this.fromModal,
					});
					/* eslint-enable no-new */
					// this.selection.save();
				},
				/* eslint-enable func-names, object-shorthand */
			});
		}
		if (this.pipingContext) {
			const { pipingContext, el, fromModal } = this;
			$.FroalaEditor.RegisterCommand('piping', {
				title: 'Piping',
				focus: false,
				undo: false,
				refreshAfterCallback: false,
				/* eslint-disable func-names, object-shorthand */
				callback: function () {
					/* eslint-disable no-new */
					new PipingModal({
						context: pipingContext,
						$textField: this.$oel,
						froala: that,
						fromModal: fromModal,
					});
					/* eslint-enable no-new */
					this.selection.save();
				},
				/* eslint-enable func-names, object-shorthand */
			});

			config = {
				at: '{{',
				lookUpOnClick: false,
				callbacks: {
					remoteFilter: (query, queryCallback) => {
						const pipeOptions = {
							url: reverse('pipes-index'),

							data: {
								q: query.trim(),
								context: this.pipingContext,
							},
							callback: (data) => {
								let id = 1;
								const pipes = [];

								for (const groupKey in data.result) {
									const pipeGroup = data.result[groupKey];

									for (const pipeIndex in pipeGroup.data) {
										const pipe = pipeGroup.data[pipeIndex];

										const pipeObj = {
											id,
											name: pipe.label,
											value: `{{ ${pipe.value} }}`,
										};
										id++;
										pipes.push(pipeObj);
									}
								}
								queryCallback(pipes);
							},
						};
						ajax.get(pipeOptions);
					},
					// Overwrite matcher so we can accept spaces
					matcher: (flag, subtext, shouldStartWithSpace) => {
						let _a;
						let _y;
						let match;
						let regexp;
						let space;
						flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

						if (shouldStartWithSpace) {
							flag = `(?:^|\\s)${flag}`;
						}

						_a = decodeURI('%C3%80');
						_y = decodeURI('%C3%BF');
						space = '\ '; // these spaces
						regexp = new RegExp(`${flag}([A-Za-z${_a}-${_y}0-9_${space}\'\.\+\-]*)$|${flag}([^\\x00-\\xff]*)$`, 'gi');
						match = regexp.exec(subtext);
						if (match) {
							return match[2] || match[1];
						}
						return null;
					},
					// Overwrote sorter so we can trim whitespace
					sorter: (query, items, searchKey) => {
						let _results;
						let i;
						let item;
						let len;
						if (!query) {
							return items;
						}
						_results = [];
						for (i = 0, len = items.length; i < len; i++) {
							item = items[i];
							item.atwho_order = new String(
								item[searchKey],
							).toLowerCase().indexOf(query.toLowerCase().trim()); // trims here
							if (item.atwho_order > -1) {
								_results.push(item);
							}
						}
						return _results.sort((a, b) => a.atwho_order - b.atwho_order);
					},
				},
				displayTpl: '<li>${name} <small>${value}</small></li>',
				insertTpl: '<span class="sma-pipe" data-toggle="tooltip" data-placement="top" title="${name}">${value}</span>',
				limit: 100,
			};
		} else {
			const index = buttons.indexOf('piping');
			if (index > -1) {
				buttons.splice(index, 1);
			}
		}

		this.el.on('froalaEditor.initialized', (e, editor) => {
			const defaultEditorValue = editor.html.get(true);
			// Remove any iframes that are not part of the default content or initial content
			if(defaultEditorValue && defaultEditorValue.length > 0) {
				editor.html.set(removeIframesExcept(defaultEditorValue));
			}

			if (this.pipingContext) {
				editor.$el.atwho(config).on('inserted.atwho', () => {
					editor.$el.find('.atwho-inserted').removeAttr('contenteditable');
				});
			}

			editor.events.on('commands.after', (cmd) => {
				if (cmd === 'html' && editor.codeView.isActive()) {
					this.initialCodeViewContent = editor.codeView.get();
				}
			}, true);

			editor.events.on('commands.before', (cmd) => {
				if (cmd === 'html' && editor.codeView.isActive() && editor.codeView.get() !== this.initialCodeViewContent) {
					const updatedContent = removeIframesExcept(editor.codeView.get());
					editor.html.set(updatedContent);
					this.initialCodeViewContent = '';
				}
			}, true);

			editor.events.on('keydown', (keydownEvent) => {
				let returnValue;
				if (keydownEvent.which === $.FroalaEditor.KEYCODE.ENTER && editor.$el.atwho('isSelecting')) {
					returnValue = false;
				}
				return returnValue;
			}, true);
		}).froalaEditor({
			heightMin: options.heightMin || 200,
			imageEditButtons: [
				'imageAlign', 'imageCaption', 'imageRemove', '|',
				'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '|',
				'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize',
			],
			imageInsertButtons: ['imageBack', '|', 'imageByURL'],
			imagePaste: false,
			imageUploadRemoteUrls: false,
			language: ({ 'en-ca': 'en_ca', 'en-gb': 'en_gb', 'es': 'es', 'fr': 'fr', 'fr-ca': 'fr' })[window.__LANGUAGE] || window.__LANGUAGE,
			placeholderText: options.placeholderText || null,
			toolbarButtons: buttons,
		});

		this.el.on('froalaEditor.contentChanged', () => {
			this.el.val(this.getContent()).change();
			this.renderVideoElements();
		});
	}

	setContent(content) {
		this.el.froalaEditor('html.set', content);
		this.el.froalaEditor('events.trigger', 'charCounter.update');
		this.renderVideoElements();
	}

	getContent() {
		return this.el.froalaEditor('html.get', true);
	}

	clean() {
		$('.edit_video_button').remove();
		$('.delete_video_button').remove();
	}

	insertVideoPiping(videoPiping, el) {
		const insertedContent = `
			<span
				class="sma-video"
				data-toggle="tooltip"
				data-placement="top"
				title="Video">
					${videoPiping}
			</span><p></p>
			`;
		el.froalaEditor('selection.restore');
		el.froalaEditor('html.insert', insertedContent, true);
		el.froalaEditor('events.trigger', 'contentChanged');
	}

	insertText(tags, el) {
		let insertedContent = tags.map((tag) => `<span class="atwho-inserted" data-atwho-at-query="{{"><span
						class="sma-pipe"
						data-toggle="tooltip"
						data-placement="top"
						title="${tag.group} ${tag.label}"
					>{{ ${tag.value} }}</span></span>`);
		insertedContent = insertedContent.join(' ');
		el.froalaEditor('selection.restore');
		el.froalaEditor('html.insert', insertedContent, true);
	}

	renderVideoElements() {
		const editor = this;
		editor.el.parent().find('.form-video-element').each(function () {
			const that = $(this);
			const regex = /\{\{\s*(\w+):([\w\-]+):(\d+):(\d+)\s*\}\}/;
			const main_element = that.parent().parent();
			const iframe = main_element.find('iframe');
			const matches = that.text().match(regex);

			if (matches && iframe.length > 0 && iframe.attr('src').includes(matches[2])) {
				return;
			}
			iframe.remove();

			if (matches) {
				const platform = matches[1];
				const id = matches[2];
				const width = matches[3];
				const height = matches[4];
				let video_url = `https://www.youtube.com/embed/${id}`;

				if (platform === 'Vimeo') {
					video_url = `https://player.vimeo.com/video/${id}`;
				}
				that.attr('style', 'display: none');
				main_element.attr('style', 'display: flex; position: relative;');
				main_element.attr('contenteditable', 'false');
				main_element.attr('class', 'fr-deletable');
				main_element.find('.edit_video_button').remove();
				const edit_button = $('<button id="" type="button" class="nc-icon-mini ui-1_pencil edit_video_button" style="position: absolute; color: lightgray; 5px; top: 5px; right: 25px; background: transparent; border: 0; cursor: pointer"></button>');
				edit_button.on('click', () => {
					new VideoWindowModal({
						context: {},
						$textField: editor.el,
						froala: editor,
						edit_element: that,
						fromModal: editor.fromModal,
						videoLink: video_url,
						width,
						height,
					});
				});
				main_element.append(edit_button);

				main_element.find('.delete_video_button').remove();
				const delete_button = $('<button id="" type="button" class="nc-icon-mini ui-1_trash-simple delete_video_button" style="position: absolute; color: lightgray; 5px; top: 5px; right: 5px; background: transparent; border: 0; cursor: pointer"></button>');
				delete_button.on('click', () => {
					main_element.remove();
				});
				main_element.append(delete_button);
				main_element.append(`<iframe frameborder="0" width="${width}" height="${height}" src="${video_url}" ></iframe>`);
			}
		});
	}
}

/* eslint-enable import/prefer-default-export */

// convert all sma-text-editor textareas
$(() => {
	$('textarea.sma-text-editor').each((i, textarea) => {
		const contextString = $(textarea).attr('data-context');
		const context = contextString ? contextString.split(' ') : null;

		new TextEditor({
			textarea,
			piping: context,
		});
	});
});

module.exports = TextEditor;
